import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { Block, Content, StyledImage, StyledLink } from './styles';

// * className {string} a className from CMS that controls styling
// * image {obj} the data for the image if displayed
// * imageAlignment {string} determines what side the image should be on
// * title {richText} data that makes up the title of the section
// * bodyText {richText} data that makes up the body of the section

const GraphicContentBlock = ({ sectionId, className, data }) => {
  if (!data) return null;
  const {
    imageAlignment,
    image,
    imageSharp,
    titleHtml,
    bodyTextHtml,
    ctaLink,
    ctaText,
    ctaType,
    queryString,
    ariaLabel,
  } = data;

  return (
    <Block id={sectionId} className={[className, imageAlignment]}>
      <StyledImage src={imageSharp} alt={image.altTag} />
      <Content>
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(bodyTextHtml)}
        {ctaText && ctaLink && (
          <StyledLink
            to={`${ctaLink.url}/`}
            className={ctaType}
            ariaLabel={ariaLabel}
            queryString={queryString}
          >
            {ctaText}
          </StyledLink>
        )}
      </Content>
    </Block>
  );
};

GraphicContentBlock.propTypes = {
  className: PropTypes.string,
  sectionId: PropTypes.string.isRequired,
  data: PropTypes.shape().isRequired,
};

GraphicContentBlock.defaultProps = {
  className: null,
};

export default GraphicContentBlock;
